import PageView from './PageView';
import addToCart from './addToCart';
import addToWishList from './addToWishList';
import ProductView from './ProductView';
var events = {
  'addtocart:success': [addToCart],
  pageview: [PageView, ProductView],
  'product:wishlist:click': [addToWishList]
};
export default events;